import { Type } from '@sinclair/typebox';
export const baseCommandSchema = Type.Object({
    /** This id is just use for internal housekeeping when correlating commands in the request and response */
    id: Type.String(),
});
//# sourceMappingURL=shared.js.map